import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'

var firebaseConfig = {
  apiKey: "AIzaSyAR9B6XzLKreRvLTMNjsE3E8O1C1FCP68o",
  authDomain: "sc-madness.firebaseapp.com",
  databaseURL: "https://sc-madness.firebaseio.com",
  projectId: "sc-madness",
  storageBucket: "sc-madness.appspot.com",
  messagingSenderId: "604991786707",
  appId: "1:604991786707:web:4fa78f365c23a53bca8e26"
};

// Get a Firestore instance
firebase.initializeApp(firebaseConfig);

// Export types that exists in Firestore
// This is not always necessary, but it's used in other examples
const { Timestamp, GeoPoint } = firebase.firestore
export { Timestamp, GeoPoint }

const db = firebase.firestore();
const fa = firebase.auth();

export {db, fa};



// db.collection('users').get().then(users => {
//   users.forEach(user => {
//     console.log(user.data().fname, user.data().lname);
//   })
// })

// let teams = [
//   {
//     R1_01: {name: 'Gonzaga', seed: 1, elim: false, round: 0},
//     R1_16: {name: 'Norfolk St/App St', seed: 16, elim: false, round: 0},
//     R1_08: {name: 'Oklahoma', seed: 8, elim: false, round: 0},
//     R1_09: {name: 'Missouri', seed: 9, elim: false, round: 0},
//     R1_05: {name: 'Creighton', seed: 5, elim: false, round: 0},
//     R1_12: {name: 'UCSB', seed: 12, elim: false, round: 0},
//     R1_04: {name: 'Virginia', seed: 4, elim: false, round: 0},
//     R1_13: {name: 'Ohio', seed: 13, elim: false, round: 0},
//     R1_06: {name: 'USC', seed: 6, elim: false, round: 0},
//     R1_11: {name: 'Wichita St/Drake', seed: 11, elim: false, round: 0},
//     R1_03: {name: 'Kansas', seed: 3, elim: false, round: 0},
//     R1_14: {name: 'E Washington', seed: 14, elim: false, round: 0},
//     R1_07: {name: 'Oregon', seed: 7, elim: false, round: 0},
//     R1_10: {name: 'VCU', seed: 10, elim: false, round: 0},
//     R1_02: {name: 'Iowa', seed: 2, elim: false, round: 0},
//     R1_15: {name: 'Grand Canyon', seed: 15, elim: false, round: 0},
//   },
//   {
//     R2_01: {name: 'Michigan', seed: 1, elim: false, round: 0},
//     R2_16: {name: 'Mt St Marys/Texas So', seed: 16, elim: false, round: 0},
//     R2_08: {name: 'LSU', seed: 8, elim: false, round: 0},
//     R2_09: {name: 'St Bonaventure', seed: 9, elim: false, round: 0},
//     R2_05: {name: 'Colorado', seed: 5, elim: false, round: 0},
//     R2_12: {name: 'Georgetown', seed: 12, elim: false, round: 0},
//     R2_04: {name: 'Florida St', seed: 4, elim: false, round: 0},
//     R2_13: {name: 'UNC Greensboro', seed: 13, elim: false, round: 0},
//     R2_06: {name: 'BYU', seed: 6, elim: false, round: 0},
//     R2_11: {name: 'Michigan St/UCLA', seed: 11, elim: false, round: 0},
//     R2_03: {name: 'Texas', seed: 3, elim: false, round: 0},
//     R2_14: {name: 'Abilene Christian', seed: 14, elim: false, round: 0},
//     R2_07: {name: 'UConn', seed: 7, elim: false, round: 0},
//     R2_10: {name: 'Maryland', seed: 10, elim: false, round: 0},
//     R2_02: {name: 'Alabama', seed: 2, elim: false, round: 0},
//     R2_15: {name: 'Iona', seed: 15, elim: false, round: 0},
//   },
//   {
//     R3_01: {name: 'Baylor', seed: 1, elim: false, round: 0},
//     R3_16: {name: 'Hartford', seed: 16, elim: false, round: 0},
//     R3_08: {name: 'North Carolina', seed: 8, elim: false, round: 0},
//     R3_09: {name: 'Wisconsin', seed: 9, elim: false, round: 0},
//     R3_05: {name: 'Villanova', seed: 5, elim: false, round: 0},
//     R3_12: {name: 'Winthrop', seed: 12, elim: false, round: 0},
//     R3_04: {name: 'Purdue', seed: 4, elim: false, round: 0},
//     R3_13: {name: 'Nprth Texas', seed: 13, elim: false, round: 0},
//     R3_06: {name: 'Texas Tech', seed: 6, elim: false, round: 0},
//     R3_11: {name: 'Utah St', seed: 11, elim: false, round: 0},
//     R3_03: {name: 'Arkansas', seed: 3, elim: false, round: 0},
//     R3_14: {name: 'Colgate', seed: 14, elim: false, round: 0},
//     R3_07: {name: 'Florida', seed: 7, elim: false, round: 0},
//     R3_10: {name: 'Virginia Tech', seed: 10, elim: false, round: 0},
//     R3_02: {name: 'Ohio St', seed: 2, elim: false, round: 0},
//     R3_15: {name: 'Oral Roberts', seed: 15, elim: false, round: 0},
//   },
//   {
//     R4_01: {name: 'Illinois', seed: 1, elim: false, round: 0},
//     R4_16: {name: 'Drexel', seed: 16, elim: false, round: 0},
//     R4_08: {name: 'Loyola Chicago', seed: 8, elim: false, round: 0},
//     R4_09: {name: 'Georgia Tech', seed: 9, elim: false, round: 0},
//     R4_05: {name: 'Tennessee', seed: 5, elim: false, round: 0},
//     R4_12: {name: 'Oregon St', seed: 12, elim: false, round: 0},
//     R4_04: {name: 'Oklahoma St', seed: 4, elim: false, round: 0},
//     R4_13: {name: 'Liberty', seed: 13, elim: false, round: 0},
//     R4_06: {name: 'San Diego St', seed: 6, elim: false, round: 0},
//     R4_11: {name: 'Syracuse', seed: 11, elim: false, round: 0},
//     R4_03: {name: 'West Virginia', seed: 3, elim: false, round: 0},
//     R4_14: {name: 'Morehead St', seed: 14, elim: false, round: 0},
//     R4_07: {name: 'Clemson', seed: 7, elim: false, round: 0},
//     R4_10: {name: 'Rutgers', seed: 10, elim: false, round: 0},
//     R4_02: {name: 'Houston', seed: 2, elim: false, round: 0},
//     R4_15: {name: 'Cleveland St', seed: 15, elim: false, round: 0},
//   }
// ]

// db.collection('data').doc('2021').update({teams: teams})